import styled from 'styled-components';
import Icon from 'antd/lib/icon';

export const DeleteIcon = styled(Icon)`
    margin-top: 10px;
`;
